import { render, staticRenderFns } from "./WatermarkUploadWrapper.vue?vue&type=template&id=2fa9ca1e&scoped=true"
import script from "./WatermarkUploadWrapper.vue?vue&type=script&lang=js"
export * from "./WatermarkUploadWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa9ca1e",
  null
  
)

export default component.exports